export default __webpack_public_path__ + "static/media/mixkit-quick-jump-arcade-game-239.80f01a1b.wav";